import _Tabs from './conferenceTab';
import TabPane from './conferenceTabPane';
var ConferenceTab = Object.assign(_Tabs, {
  TabPane: TabPane
});
export default ConferenceTab;
export { ConferenceTab };